// List of major German public health insurance companies (Gesetzliche Krankenkassen)
// Users can also type their own insurance company name if not in this list

export const GERMAN_PUBLIC_INSURANCE_COMPANIES = [
	"AOK Baden-Württemberg",
	"AOK Bayern",
	"AOK Bremen/Bremerhaven",
	"AOK Hessen",
	"AOK Niedersachsen",
	"AOK Nordost",
	"AOK Nordwest",
	"AOK Plus (Sachsen/Thüringen)",
	"AOK Rheinland-Pfalz/Saarland",
	"AOK Rheinland/Hamburg",
	"AOK Sachsen-Anhalt",
	"BARMER",
	"Techniker Krankenkasse (TK)",
	"DAK-Gesundheit",
	"KKH Kaufmännische Krankenkasse",
	"hkk Krankenkasse",
	"HEK - Hanseatische Krankenkasse",
	"IKK classic",
	"IKK Südwest",
	"IKK gesund plus",
	"Mobil Krankenkasse",
	"BKK VBU",
	"BKK24",
	"BKK Pfalz",
	"BKK firmus",
	"Debeka BKK",
	"mhplus Betriebskrankenkasse",
	"Novitas BKK",
	"pronova BKK",
	"SBK Siemens-Betriebskrankenkasse",
	"vivida bkk",
	"VIACTIV Krankenkasse",
	"KNAPPSCHAFT",
	"Sozialversicherung für Landwirtschaft, Forsten und Gartenbau (SVLFG)",
].sort();
